export { FlagSize } from './flag.component';
